import BaseDTO from '../base/BaseDTO';

export default class PreviewDTO extends BaseDTO {
    public resolution: string | undefined;
    public format: string | undefined;
    public size: string | undefined;
    public duration: number | undefined;
    public status: string | undefined;
    public cloudfrontUrl: string | undefined;

    constructor(data: { [key: string]: any }) {
        super(data);
        this.resolution = data['resolution'] || undefined;
        this.format = data['format'] || undefined;
        this.size = data['size'] || undefined;
        this.duration = data['duration'] || undefined;
        this.status = data['status'] || undefined;
        this.cloudfrontUrl = data['cloudfrontUrl'] || undefined;
    }
}
